import styled from 'styled-components';
import Button from '../../../../../stories/core-components/Button/Button';
import SearchInputIcon from '../../../../../stories/Icons/SearchInputIcon';

export const LocationMapContainer = styled.section(
  props => `
  width: 100%;
  margin: ${props.theme.spacing.large.l50} auto 0;
  max-width: 120rem;
`,
);

export const LocationMapHeader = styled.div(
  props => `
  width: 100%;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.nospacing};
`,
);

export const LocationMapHeaderInnerWrap = styled.div(
  props => `
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`,
);

export const LocationMapHeaderText = styled.div(
  props => `
  font-size: ${props.theme.font.large.font22};
  color: ${props.theme.colors.black.base};
  font-weight: ${props.theme.font.fontWeight.black};
`,
);

export const LocationMapHeadSubTextWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    justify-contnet: space-between;
    align-items: center;
    padding-top: ${props.theme.spacing.small.s5};
  `
);

export const LocationHotelAddressText = styled.p(
  props => `
    width: 60%;
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.grey.base};
  `
);

export const LocationHotelReviewText = styled.p(
  props => `
    width:40%;
    text-align: right;
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.grey.base};
    font-weight: ${props.theme.font.fontWeight.bold};
  `
);

export const ContentContainer = styled.div(
  props => `
  display: flex;
  height: 42rem;
  position: relative;
  border: solid 1px rgba(0, 0, 0, 0.1);
  border-radius: ${props.theme.misc.borderRadius.base};
  background: ${props.theme.colors.white.base};
`,
);

export const WhatIsAroundContainer = styled.div(
  props => `
  flex: 0.26;
  display: flex;
  flex-direction: column;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  overflow: auto;
`,
);

export const MapContainer = styled.div(
  props => `
  flex: ${props.flex || 0.74};
  text-align: center;
  height: 100%;
`,
);

export const WhatIsAroundContainerHeader = styled.h3(
  props => `
  padding: ${props.theme.spacing.large.l20};
  background: ${props.theme.colors.blue.bgBlue};
  color: ${props.theme.colors.black.base};
  font-size:${props.theme.font.large.font16};
  font-weight :bold;
  flex: 0.06;
`,
);

export const PlacesListContainer = styled.div(
  props => `
  // display: flex;
  // flex-direction: column;
  // height: 86%;
  flex: 0.94;
  margin: 0 ${props.theme.spacing.large.l15} 0;
`,
);

export const List = styled.ul(
  props => `
  flex: 1;
  // padding: ${props.theme.spacing.large.l20};
  list-style-type: none;
`,
);

export const ListItemWrapper = styled.div(
  props => `
  display: flex;
  align-items: baseline;
  padding: 0 0 ${props.theme.spacing.base};
`,
);

export const ListItem = styled.li(
  props => `
  cursor: pointer;
  // display: flex;
  // align-items: baseline;
`,
);

export const ListItemText = styled.span(
  props => `
  color: ${props.theme.colors.black.base};
`,
);

export const DistanceText = styled.div(
  props => `
  color: ${props.theme.colors.grey.base1};
  margin: ${props.theme.spacing.small.s1} 0 0 0;
`,
);

export const ListItemTextsContainer = styled.div(
  props => `
  margin: 0 0 0 ${props.theme.spacing.base};  
`,
);

export const ListHeading = styled.h4(
  props => `
  font-weight :bold;
  color: ${props.theme.colors.grey.light9b};
  font-size:${props.theme.font.large.font14};
  margin: ${props.theme.spacing.large.l15} 0;
`,
);

export const ListBoxWrapper = styled.aside(
  props => `
  display: flex;
  flex-direction: column;
  height: 100%;

  ${List}:nth-of-type(1) {
    border-bottom: 1px solid ${props.theme.colors.blue.bgBlue};
  }
`,
);

export const GreenRound = styled.div(
  props => `
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${props.active ? props.theme.colors.yellow.base : props.theme.colors.green.base};
`,
);

export const MapLink = styled.a(
  props => `
  height: 100%;
`,
);

export const MapImage = styled.img(
  props => `
  height: 100%;
`,
);

export const MapActionButton = styled(Button)(
  props => `
  padding: ${props.theme.spacing.base};
  font-weight: bold;
  font-size: ${props.theme.font.small.font11};
  align-items: center;
  background-color: ${props.theme.colors.blue.base};
  color: ${props.theme.colors.white.base};
  box-shadow: ${props.theme.colors.grey.light9b} 0px 1px 4px -1px;
  border-radius: 34px;
  &:focus{
    box-shadow: none;
    outline-offset: 0;
    outline: 0;
  }
`,
);

export const MapActionButtonContainer = styled.div(
  props => `
  position: absolute;
  top: ${props.theme.spacing.large.l12};
  right: 5rem;
  z-index: ${props.theme.misc.zIndex.small};
`,
);


export const SearchNearByLocation = styled.div(
  props => `
    background-color: ${props.theme.colors.white.bgWhite1};
    // border-radius: ${props.theme.misc.borderRadius.base};
    border-bottom: solid 1px rgba(0,0,0,0.1);
`,
);

export const InputWrapper = styled.div(
  props => `
    display: flex;
    width: 90%;
    padding: ${props.theme.spacing.small.s8};
    border-radius: ${props.theme.misc.borderRadius.base};
    border: solid 1px rgba(0,0,0,0.1);
    background-color: #ffffff;
    margin: ${props.theme.spacing.large.l15};
  `
);

export const LocationSearchInput = styled.input(
  props => `
  width: 100%;
  border: none;
  font-size: ${props.theme.font.base};
  color: ${props.theme.colors.black.base};
  ::placeholder {
    color: ${props.theme.colors.grey.light9b};
    overflow:visible;
  }
  &:focus{
    box-shadow: none;
    outline-offset: 0;
    outline: 0;
  }
  `,
);

export const SearchIconWrap = styled(SearchInputIcon)(
  props => `
  width: ${props.theme.spacing.large.l18};
  height: ${props.theme.spacing.large.l18};
  fill: ${props.theme.colors.grey.base1}
`,
);

export const AutoSuggestOuterWrapper = styled.div(
  props => `
    display:flex;
    margin: 0 ${props.theme.spacing.xxlarge} ${props.theme.spacing.xxlarge};
    position:relative;
    padding-top: ${props.theme.spacing.base};
`,
);

export const AutoSuggestContainer = styled.div(
  props => `
    position:relative;
    width:28.6rem;
    padding: ${props.theme.spacing.small.s5} ${props.theme.spacing.base};
    margin-right: ${props.theme.spacing.base};
    border-radius: ${props.theme.misc.borderRadius.base};
    background:${props.theme.colors.white.bgWhite1};
    border: 0.1rem solid rgba(0,0,0,0.1);
  `,
);

export const LocationMapOuterWrap = styled.div(
  props => `
  display:flex;
  justify-content:space-between;
  align-items:center;
`,
);

export const LocationMapWrapper = styled.div(
  props => `
  display:flex;
  align-items:center;
  padding-top:${props.theme.spacing.small};
`,
);

export const LocationNameToolTip = styled.span(
  props => `
  visibility: hidden;
  background-color: ${props.theme.colors.grey.light9b};
  color: ${props.theme.colors.white.base};
  border-radius: ${props.theme.misc.borderRadius.large};
  padding: ${props.theme.spacing.small} ${props.theme.spacing.base};
  /* Position the tooltip */
  position: absolute;
  left:1.5rem;
  top:3rem;
  z-index:1;
`,
);

export const LocationName = styled.div(
  props => `
  color: ${props.theme.colors.grey.dark3e};
  font-size: ${props.theme.font.large.font14};
  font-weight:bold;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width:22rem;
  cursor:pointer;
  &:hover > ${LocationNameToolTip} {
    visibility: visible;
  }
`,
);

export const TimeDistanceDurationWrapper = styled.div(
  props => `
  padding-top:${props.theme.spacing.base};
`,
);

export const TimeDuration = styled.span(
  props => `
  color: ${props.theme.colors.grey.light9b};
  font-size: ${props.theme.font.large.font14};
`,
);

export const DistanceDuration = styled.span(
  props => `
  color: ${props.theme.colors.grey.light9b};
  font-size: ${props.theme.font.large.font14};
  padding-right: ${props.theme.spacing.small};
`,
);


